import { render, staticRenderFns } from "./managePrompts.vue?vue&type=template&id=1a550314&"
import script from "./managePrompts.vue?vue&type=script&lang=js&"
export * from "./managePrompts.vue?vue&type=script&lang=js&"
import style0 from "./managePrompts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports